// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-property-value-disallowed-list -- DS component */
/* stylelint-disable property-disallowed-list -- DS component */
.MessageBox-module__Container__l5Wlv {
    display: flex;
    gap: var(--ds-s);
    justify-content: flex-start;
    width: 100%;
    padding: var(--ds-sm) var(--ds-m);
    border-radius: var(--ds-border-radius-m);
}

.MessageBox-module__Alert__h7ogF {
    color: var(--ds-color-alert);
    background: var(--ds-color-alert-bg);
}

.MessageBox-module__Error__CmiWR {
    color: var(--ds-color-negative);
    background: var(--ds-color-negative-bg);
}

.MessageBox-module__Info__KQTUk {
    color: var(--ds-color-informative);
    background: var(--ds-color-informative-bg);
}

.MessageBox-module__Success__pLCNw {
    color: var(--ds-color-positive);
    background: var(--ds-color-positive-bg);
}

.MessageBox-module__AlignStart__TZyrP {
    align-items: flex-start;
}

.MessageBox-module__AlignCenter__EVgF9 {
    align-items: center;
}

.MessageBox-module__Icon__ZMZ2L {
    display: flex;
    line-height: var(--ds-line-height-paragraph);
}

.MessageBox-module__Content__AXQu_ {
    overflow: hidden;
    font-weight: var(--ds-font-weight-regular);
    font-size: var(--ds-font-size-s);
    line-height: var(--ds-line-height-paragraph);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `MessageBox-module__Container__l5Wlv`,
	"Alert": `MessageBox-module__Alert__h7ogF`,
	"Error": `MessageBox-module__Error__CmiWR`,
	"Info": `MessageBox-module__Info__KQTUk`,
	"Success": `MessageBox-module__Success__pLCNw`,
	"AlignStart": `MessageBox-module__AlignStart__TZyrP`,
	"AlignCenter": `MessageBox-module__AlignCenter__EVgF9`,
	"Icon": `MessageBox-module__Icon__ZMZ2L`,
	"Content": `MessageBox-module__Content__AXQu_`
};
export default ___CSS_LOADER_EXPORT___;
